import type {CSSProperties} from "react";
import {twJoin} from "tailwind-merge";
import {AnankeSkeleton} from "@vesta/ananke/components/anankeSkeleton";
import {AnankeSpinner} from "@vesta/ananke/components/anankeSpinner";

export function GenericLoadingComponent({
    className,
    style,
}: {
    className?: string;
    style?: CSSProperties;
    //
}) {
    return (
        <div
            className={twJoin(
                "w-full h-full",
                "relative",
                className,
                //
            )}
            style={style}
        >
            {/* <div className="absolute inset-0 z-10 grid grid-cols-1 grid-rows-1 place-items-center content-center">Loading</div> */}
            <div className="absolute inset-0 z-10 grid grid-cols-1 grid-rows-1 place-items-center content-center">
                <AnankeSpinner
                    label=""
                />
            </div>
            <AnankeSkeleton
                width="100%"
                height="100%"
            />
        </div>
    );
}
